const youtubeEmbedUrl = (youtubeId, muted) => {
  const params = new URLSearchParams({
    autoplay: "1", mute: muted ? "1" : "0", rel: "0", modestbranding: "1",
    playsinline: "1", controls: "0", iv_load_policy: "3", fs: "0", enablejsapi: "1",
  });
  return `https://www.youtube.com/embed/${youtubeId}?${params.toString()}`;
};

/** Renders the media of the current short (YouTube iframe or native video). */
export const ShortsStage = ({ current, muted, onEnded }) => {
  if (!current) return null;
  if (current.source_type === "youtube" && current.youtube_id) {
    return (
      <iframe
        key={current.id + String(muted)}
        src={youtubeEmbedUrl(current.youtube_id, muted)}
        title={current.title}
        allow="autoplay; encrypted-media; picture-in-picture"
        allowFullScreen
        className="absolute inset-0 w-full h-full border-0"
        data-testid="shorts-iframe"
      />
    );
  }
  return (
    <video
      key={current.id}
      src={current.source_url}
      poster={current.thumbnail}
      autoPlay
      loop
      muted={muted}
      playsInline
      onEnded={onEnded}
      className="absolute inset-0 w-full h-full object-cover"
      data-testid="shorts-video"
    />
  );
};
